import { apiRequest } from "./apiClient";

export type LoginResponse = {
  accessToken: string;
  tokenType: string;
};

export type UserRole = {
  roleId: number;
  roleName: string;
  statusId: number;
};

export type UserZone = {
  zoneId: number;
  zoneName: string;
  statusId: number;
};

export type UserPump = {
  pumpId: number;
  pumpName: string;
  zoneId: number;
  zoneName: string;
  statusId: number;
  pumpBalance: number | null;
};

export type AuthenticatedUser = {
  id: number;
  userName: string;
  email: string;
  statusId: number;
  name?: string | null;
  surname?: string | null;
  cellPhone?: string | null;
  roles?: UserRole[] | null;
  zones?: UserZone[] | null;
  pumps?: UserPump[] | null;
};

export async function loginRequest(username: string, password: string) {
  const params = new URLSearchParams();
  params.append("username", username);
  params.append("password", password);
  return apiRequest<LoginResponse>("/api/auth/login", {
    method: "POST",
    body: params,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    authenticated: false,
  });
}

export async function fetchCurrentUser() {
  return apiRequest<AuthenticatedUser>("/api/auth/me");
}
